function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { AlertsBus } from 'modules/App';
import messages from '../../messages';
import SetNewPasswordCCForm from '../../partials/SetNewPasswordCCForm';
var _React_PureComponent;
class SetNewPasswordCC extends (_React_PureComponent = React.PureComponent) {
    renderContourCloudInfo() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row mb-8",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/aid/assets/svg/contour-logo.svg",
                        alt: "Contour Cloud"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col text--large text-lh--133",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.changeContourCloudPass))
                })
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.setNewPassword));
    }
    renderAlerts() {
        return /*#__PURE__*/ _jsx(AlertsBus, {
            className: "mb-5"
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "pageContentBox pageContentBox--sm",
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "pageHeader",
                    children: /*#__PURE__*/ _jsx("h1", {
                        className: "text--h2",
                        children: this.renderHeader()
                    })
                }),
                this.renderAlerts(),
                this.renderContourCloudInfo(),
                /*#__PURE__*/ _jsx(SetNewPasswordCCForm, _object_spread({}, this.props))
            ]
        });
    }
}
_define_property(SetNewPasswordCC, "propTypes", {
    // Explicit props
    email: PropTypes.string.isRequired,
    identityProviderKey: PropTypes.string.isRequired,
    temporaryPassword: PropTypes.string.isRequired
});
export default SetNewPasswordCC;
